import { render, staticRenderFns } from "./whatsapp-utm.vue?vue&type=template&id=6108af86&scoped=true"
import script from "./whatsapp-utm.vue?vue&type=script&lang=js"
export * from "./whatsapp-utm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108af86",
  null
  
)

export default component.exports